/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InvestmentStyleDiagnosisAnxietyScore model module.
 * @module model/InvestmentStyleDiagnosisAnxietyScore
 * @version 1.0.0
 */
class InvestmentStyleDiagnosisAnxietyScore {
    /**
     * Constructs a new <code>InvestmentStyleDiagnosisAnxietyScore</code>.
     * @alias module:model/InvestmentStyleDiagnosisAnxietyScore
     */
    constructor() { 
        
        InvestmentStyleDiagnosisAnxietyScore.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvestmentStyleDiagnosisAnxietyScore</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentStyleDiagnosisAnxietyScore} obj Optional instance to populate.
     * @return {module:model/InvestmentStyleDiagnosisAnxietyScore} The populated <code>InvestmentStyleDiagnosisAnxietyScore</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentStyleDiagnosisAnxietyScore();

            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('score')) {
                obj['score'] = ApiClient.convertToType(data['score'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentStyleDiagnosisAnxietyScore</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentStyleDiagnosisAnxietyScore</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}



/**
 * @member {module:model/InvestmentStyleDiagnosisAnxietyScore.KeyEnum} key
 */
InvestmentStyleDiagnosisAnxietyScore.prototype['key'] = undefined;

/**
 * @member {Number} score
 */
InvestmentStyleDiagnosisAnxietyScore.prototype['score'] = undefined;





/**
 * Allowed values for the <code>key</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisAnxietyScore['KeyEnum'] = {

    /**
     * value: "loan"
     * @const
     */
    "loan": "loan",

    /**
     * value: "vacancy"
     * @const
     */
    "vacancy": "vacancy",

    /**
     * value: "exit"
     * @const
     */
    "exit": "exit",

    /**
     * value: "repair"
     * @const
     */
    "repair": "repair",

    /**
     * value: "sales_pressure"
     * @const
     */
    "sales_pressure": "sales_pressure"
};



export default InvestmentStyleDiagnosisAnxietyScore;

